import React from "react";

class CustomerReviews extends React.Component {
  componentDidMount() {
    const $ = window.$;
    $(this.refs.reviews).owlCarousel({
      'items': 1,
      'loop': true,
      'autoPlay': 5000,
      'itemsDesktop': [1200, 1],
      'itemsTablet': [980, 1],
      'itemsMobile': [700, 1]
    });
  }
  render() {
    return (
        <section className="section app-seciton" style={{background: "url(../images/app-back.jpg)", padding: "145px 0"}}>

          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="text-left">
                  <h1 className="Title">MightyWifi App<span className="d-break">Download</span></h1>
                  <div className="app-text">
                    Please download the MightyWifi App to keep track of your data usage and to recharge data. <span className="d-break">The app is available on Google Play and Apple App Store.</span>
                  </div>
                  <div className="app-btn">
                    <span className="app-btn-io icon-ios"><a href="https://apps.apple.com/us/app/mightywifi/id1459407290"><img src="/images/ios-app.svg"/></a></span>
                    <span className="app-btn-android icon-android"><a href="https://play.google.com/store/apps/details?id=com.hqylkj.lc.mightywifi"><img src="/images/android-app.svg"/></a></span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
              </div>

            </div>
          </div>
        </section>
    );
  }
}

export default CustomerReviews;



// WEBPACK FOOTER //
// ./src/layout/MightyWifiApp.js